import { Field, Form, getIn, withFormik } from 'formik';
import React from 'react';
import { Button, Col, Modal, Row } from 'react-bootstrap';
import * as Yup from 'yup';
import { FormikSelect } from '../../../components';

const DocumentSelector = ({ showFields, formRequest, ...props }) => {
  const { errors, touched, setFieldValue } = props;
  return (
    <>
      <Form>
        <Modal.Body>
          <Row>
            <Col md={6}>
              <Field name="documentType">
                {({ field }) => (
                  <FormikSelect
                    {...field}
                    abbr
                    label="Tipo Documento"
                    placeholder="Seleccionar Tipo de Documento"
                    options={showFields}
                    onChange={data => {
                      setFieldValue(field.name, data ? data.value : '');
                    }}
                    error={getIn(errors, field.name)}
                    touched={getIn(touched, field.name)}
                  />
                )}
              </Field>
            </Col>
            <Col md={6} className="mt-4">
              <Button type="submit" className="btn" variant="primary">
                Ver Documento
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Form>
    </>
  );
};

const setInitialValues = () => {
  return {
    documentType: ''
  };
};

const validationSchema = Yup.object().shape({
  documentType: Yup.string().required('Debes seleccionar el tipo de documento')
});

const handleSubmit = (values, { props }) => {
  const { settlement, formRequest } = props;
  formRequest(values, settlement);
};

export default withFormik({
  mapPropsToValues: props => setInitialValues(props),
  validationSchema,
  handleSubmit,
  enableReinitialize: true,
  validateOnMount: false
})(DocumentSelector);
